export const faq = {
  title: "Perguntas Frequentes",
  faqs: [
    {
      question: "Quem Somos e qual o nosso objetivo?",
      answer:
        "Somos uma organização dedicada a reunir uma liga social global de atores inovadores, empreendedores e investidores com o objetivo de combater a pobreza e criar prosperidade. Utilizamos nossos conhecimentos e implementamos programas sociais efetivos alinhados aos Objetivos de Desenvolvimento Sustentável da ONU (ODS2030) para quebrar o ciclo da pobreza."
    },
    {
      question: "O que é o Living Lab?",
      answer:
        "O Living Lab é uma plataforma múltipla, tanto física quanto virtual, que aborda os Grandes Desafios do Mundo. Ele conecta empreendedores, empresas e governos para resolver desafios sociais em comunidades pobres e emergentes, atuando como um laboratório vivo para testar e demonstrar tecnologias inovadoras como impressão 3D para habitação, Inteligência Artificial para saúde, blockchain, VR, AR, e muito mais."
    },
    {
      question: "O que são os Objetivos de Desenvolvimento Sustentável (ODS)?",
      answer:
        "Os ODS são uma coleção de 17 metas globais estabelecidas pela ONU na Agenda 2030. Elas representam um apelo urgente à ação de todos os países para promover a prosperidade enquanto protegem o planeta. Nossa organização promove inovações e mobiliza uma rede de talentos locais e parcerias globais para atingir essas metas com alto impacto."
    },
    {
      question: "Como funciona nossa plataforma?",
      answer:
        "Nossa plataforma conecta desafios sociais complexos às pessoas capazes de resolvê-los, promovendo ação colaborativa e inovação aberta. Ela serve como um ponto de encontro para aqueles que buscam fazer a diferença nos desafios relacionados aos 17 objetivos de desenvolvimento sustentável da ONU."
    },
    {
      question: "Como posso submeter uma solução na plataforma?",
      answer:
        "Para submeter uma solução, siga estes passos: 1) Encontre um desafio relacionado aos ODS que você deseja resolver; 2) Aceite o desafio e forme uma equipe; 3) Siga as diretrizes e cronograma do desafio; 4) Após concluir, aguarde a avaliação do painel. As soluções vencedoras podem receber prêmios em dinheiro e a oportunidade de serem testadas em larga escala."
    },
    {
      question: "O que é o Social Impact Board?",
      answer:
        "O Social Impact Board é um grupo internacional de conselheiros que atuam junto à nossa organização em projetos ao redor do mundo. Eles desempenham um papel crucial na realização de projetos com impacto social significativo, como a 'Operation Walk'."
    },
    {
      question: "Quem são nossos parceiros?",
      answer:
        "Nossos parceiros incluem uma diversidade de ecossistemas de soluções para cada um dos 17 ODS. Eles trabalham conosco para solucionar desafios e criar modelos replicáveis em outras partes do mundo. Alguns dos nossos parceiros são: a BoP Hub, INSTITUTO ÊXITO, Fundação Terra, Operação Walk Chicago, Porto Social, Projeto C.U.R.E., Singularity University, Transforma Brasil, Instituto Trata Brasil, e a Organização Mundial do Banheiro (OMC)."
    }
  ]
};
